module.exports = __webpack_public_path__ + "static/media/hoc.e9c637d6.png";